import { ChangeDetectorRef, Component } from "@angular/core";
import { NavParams, ViewController } from "ionic-angular";
import { Subject } from "rxjs/Subject";
import { FormHelperService } from "../../services/form-helper-service/form-helper.service";
import { NewJobPopoverResult } from "./new-job-popover-result.model";
import { JobType } from "../../business-objects/job-type/job-type.model";
import { FormInlined } from "../../business-objects/form/form.model";
import { Job } from "../../business-objects/job/job.model";
import { Account } from "../../business-objects/account/account.model";
import { VasAppFacade } from "../../services/vas-app-facade.service";

export interface NewJobPopoverArgs {
    job?: Job;
    account?: Account;
}

@Component({
    selector: "new-job-popover",
    templateUrl: "new-job-popover.component.html"
})
export class NewJobPopoverComponent {

    protected ngUnsubscribe: Subject<void> = new Subject<void>();

    jobTypes: Array<JobType>;
    forms: Array<FormInlined>;
    formsByJobType: Array<FormInlined>;
    selectedJobType: JobType;
    job: Job;
    account: Account;

    constructor(
        protected viewCtrl: ViewController,
        protected navParams: NavParams,
        protected appFacade: VasAppFacade,
        protected formHelperService: FormHelperService,
        protected changeDetectorRef: ChangeDetectorRef
    ) {

    }

    ngOnInit(): void {

        this.job = this.navParams.get("job");
        this.account = this.navParams.get("account");

        if (!this.account) {
            this.appFacade.objects.account.store.getActive().take(1).subscribe(account => this.account = account);
        }


        this.appFacade.objects.jobType.store.getForAllAccounts()
            .map(list => list.filter(jobType => jobType.account === this.account.id))
            .map(list => list.filter(jobType => !this.job || jobType.id === this.job.jobType))
            .take(1)
            .subscribe(list => this.jobTypes = list.sort((a, b) => a.title.toLocaleLowerCase().localeCompare(b.title.toLocaleLowerCase())));

        this.appFacade.objects.form.store.getAllAccountsInlined()
            .map(list => list.filter(item => item.account === this.account.id))
            .take(1)
            .subscribe(list => this.forms = list.sort((a, b) => a.title.toLocaleLowerCase().localeCompare(b.title.toLocaleLowerCase())));

        if (this.job) {
            const jt = this.jobTypes.find(jobType => jobType.id === this.job.jobType);
            if (jt) {
                this.selectJobType(jt);
            }
        }
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

    onSelectJobType(jobType): void {
        this.selectJobType(jobType);
    }

    onDeSelectJobType(): void {
        this.selectJobType(undefined);
    }

    onSelectForm(form: FormInlined): void {
        this.selectForm(form);
    }

    selectJobType(jobType: JobType): void {
        this.selectedJobType = jobType;
        this.formsByJobType = this.forms
            .filter(form => this.selectedJobType && form.jobType === this.selectedJobType.id);

        this.changeDetectorRef.detectChanges();

        if (this.formsByJobType.length === 0) {
            this.close(Error('no forms for this job type'));
            return;
        }

        if (this.formsByJobType.length === 1) {
            this.selectForm(this.formsByJobType[0]);
        }
    }

    selectForm(form: FormInlined): void {
        this.close(new NewJobPopoverResult(form, this.selectedJobType));
    }

    getFormsBySelectedJobType(): Array<FormInlined> {
        return this.formsByJobType;
    }

    close(data: NewJobPopoverResult | Error): void {
        this.viewCtrl.dismiss(data);
    }

}



// WEBPACK FOOTER //
// ./src/vas/modules-shared/new-job-popover/new-job-popover.component.ts